import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";

import mutations from "./mutations";
import actions from "./actions";

if (!window.Vuex) Vue.use(Vuex);

// backwards compatible cookiecheck:
const isOldCookieConsented = Cookies.get("cookieConsented") || false;

export default new Vuex.Store({
  /* check the initial state in the localStorage */
  state: {
    user: {},
    /* added a state for notification, but we want to save settings for enabled to user */
    /* @Chris and also how do we structure the enabled notications?
    I created an empty array to which subscriptions can be added, good yesnoyes? */
    notifications: {
      support: false,
      enabled: [],
      /* temp for playing with notifications */
      reminders: false
    },
    selectedDate: new Date(),
    selectedPeriod: 0,
    cookieConsented: isOldCookieConsented
  },

  getters: {
    isKnownUser: state => typeof state.user !== "undefined" && typeof state.user.isAnonymous !== "undefined" && state.user.isAnonymous !== true,
    isLoggedIn: state => typeof state.user !== "undefined" && typeof state.user.userId !== "undefined",
    isCookieConsented: state => state.cookieConsented
  },
  mutations,
  actions,

  plugins: [
    createPersistedState({
      paths: ["cookieConsented", "selectedPeriod"],
      storage: {
        getItem: key => Cookies.get(key),
        // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
        setItem: (key, value) => {
          Cookies.set(key, value, { expires: 365 });
        },
        removeItem: key => Cookies.remove(key)
      }
    })
  ]
});
